import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResult } from "@shared/models";
import { Observable } from 'rxjs';

@Injectable()
export class StoresService {
  constructor(
    private http: HttpClient,
  ) { }
  createStore(data: any) {
    return this.http.post<ApiResult<any>>('/api/stores', data);
  }
  getStoreById(id: number): Observable<ApiResult<StoreResponse>> {
    return this.http.get<ApiResult<StoreResponse>>(`/api/stores/${id}`)
  }
  getStores() {
    return this.http.get<ApiResult<any>>(`/api/stores/my`);
  }
  updateStore(id: number, data: any) {
    return this.http.put<ApiResult<any>>(`/api/stores/${id}`, data);
  }
  delete(id: number) {
    return this.http.delete<ApiResult<boolean>>(`/api/stores/${id}`);
  }

  getSelectedCashboxesCountForServiceCenter(serviceCenterXin: string, storesIds: number[]) {
    const query = new HttpParams()
      .append("serviceCenterXin", serviceCenterXin)
      .append("storeIds", storesIds.join(','))
    return this.http.get<ApiResult<any>>(`/api/clients/current/service-centers/accessible-cashboxes-count-by-stores`,
      { params: query });
  }

  isUsed(id: number) {
    return this.http.get<ApiResult<boolean>>(`/api/stores/${id}/is-used`);
  }

  updateUsed(id: number, data: any) {
    return this.http.patch<ApiResult<boolean>>(`/api/stores/${id}/used`, data);
  }
}

export interface StoreResponse {
  id: number;
  name: string;
  address: {
    katoCode: string;
    geonimId: number;
    buildingId: number | null;
    groundId: number | null;
    premiseId: number | null;
    text: string;
    description: string;
    compatibility: number;
  };
  coordinate: {
    latitude: number;
    longitude: number;
  } | null;
}
